import { toast } from 'react-toastify';
import { sanitizeUserFacingErrorMessage } from './errorSanitizer';

export const error = (messageOrError) => {
  toast.error(sanitizeUserFacingErrorMessage(messageOrError));
}

export const success = (message) => {
  toast.success(message);
}


